const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 15,
  y: 15,
  width: 1155,
  height: 2466,
  rx: 155,
  stroke: "#373738",
  strokeWidth: 30
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M270.597 30.0001C246.868 29.9998 938.412 30.0001 914.703 30.0001C890.994 30.0001 890.994 54 890.994 54H293.994C293.994 54 294.326 30.0004 270.597 30.0001Z",
  fill: "#373738"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M294 30H891V63C891 92.2711 867.271 116 838 116H347C317.729 116 294 92.2711 294 63V30Z",
  fill: "#373738"
});
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1185,
    height: 2496,
    viewBox: "0 0 1185 2496",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.09c3307903740f3e340bd4e329f22b64.svg";
export { ForwardRef as ReactComponent };